import React, { createContext, useContext, useState } from "react";
import useAuth from "./auth";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { user: initialUser } = useAuth();
  const [user, setUser] = useState(initialUser);


  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
